import { render, staticRenderFns } from "./NavExpandedItem.vue?vue&type=template&id=1c6aa721"
import script from "./NavExpandedItem.vue?vue&type=script&lang=js"
export * from "./NavExpandedItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports